(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({"/Users/lukasz/Sites/directimport/www/resources/assets/scripts/src/main.js":[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
// import {Load}             from './modules/load';


var _svgInjector = require('./modules/svgInjector');

var _parallax = require('./modules/parallax');

var _imagePopUp = require('./modules/imagePopUp');

var _carousels = require('./modules/carousels');

var _miniGallery = require('./modules/miniGallery');

var _cookies = require('./modules/cookies');

var _scrollTo = require('./modules/scrollTo');

var _googleMaps = require('./modules/googleMaps');

var _video = require('./modules/video');

var _validator = require('./modules/validator');

var _sidePanel = require('./modules/sidePanel');

var _visible = require('./modules/visible');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var svgInjector = new _svgInjector.SvgInjector();
var parallax = new _parallax.Parallax();
var imagePopUp = new _imagePopUp.ImagePopUp();
var carousels = new _carousels.Carousels();
var miniGallery = new _miniGallery.MiniGallery();
var cookies = new _cookies.Cookies();
var scrollTo = new _scrollTo.ScrollTo();
var googleMaps = new _googleMaps.GoogleMaps();
var video = new _video.Video();
var validator = new _validator.Validator();
var sidePanel = new _sidePanel.SidePanel();
// var load              = new Load();
var visible = new _visible.Visible();

var Main = function () {
    function Main(node_env) {
        _classCallCheck(this, Main);

        this.node_env = node_env;
        this.sections = $('.cms-section');
    }

    _createClass(Main, [{
        key: 'bootstrap',
        value: function bootstrap(callback) {
            var $sections = $(this.sections);
            this.modules($sections);
            this.responsiveModules($sections);
            callback();
        }
    }, {
        key: 'modules',
        value: function modules($sections) {
            parallax.init($sections);
            svgInjector.init();
            imagePopUp.init();
            carousels.init();
            miniGallery.init();
            cookies.init();
            scrollTo.init();
            googleMaps.init();
            video.init();
            validator.init();
            sidePanel.init();
            // load.init();
            visible.init();
        }
    }, {
        key: 'responsiveModules',
        value: function responsiveModules($sections) {
            $(window).resize(function () {
                parallax.init($sections);
                carousels.init();
                miniGallery.init();
            });

            $(window).scroll(function () {
                $('.video-player').each(function (id, videoPlayer) {
                    if ($(videoPlayer).visible(true)) {
                        video.play($(videoPlayer));
                    } else {
                        video.stop($(videoPlayer));
                    }
                });
            });
        }
    }]);

    return Main;
}();

$(window).load(function () {
    var main = new Main('development');
    main.bootstrap(function () {
        $('#page-overlay').fadeOut(800);
    });
});

$(document).ready(function () {

    $('body').on('click', ".form_with_products button.add_product", function (event) {
        event.preventDefault();
        event.stopPropagation();
        var form = $(this).closest('form.form_with_products');
        var products_wrapper = form.find("div.products-wrapper");
        var last_product = products_wrapper.find("div.product-row").last();
        var product_nbr = last_product.attr('data-product');
        product_nbr = product_nbr !== undefined ? product_nbr : 0;
        var next_product = parseInt(product_nbr) + 1;
        var template = '<div class=\'form-group col-12 product-row\' data-product=\'' + next_product + '\'>\n                          <div class=\'row pr-5\'>\n                              <div class=\'col-2 col-md-1 d-flex align-items-center mb-3\'>\n                                  <span class=\'lp\'>' + next_product + '</span>\n                              </div>\n                              <div class=\'col-10 col-md-8 mb-3\'>\n                                  <input type=\'text\' class=\'w-100 p-2\' name=\'products[' + next_product + '][name]\' placeholder=\'Nazwa towaru\' required/>\n                              </div>\n                              <div class=\'col-10 offset-2 col-md-3 offset-md-0 mb-3\'>\n                                  <input type=\'number\' class=\'w-100 p-2\' name=\'products[' + next_product + '][quantity]\' min=\'0\' placeholder=\'Ilo\u015B\u0107\' required/>\n                              </div>\n                              <div class=\'col-10 offset-2 col-md-11 offset-md-1 mb-3\'>\n                                  <input type=\'text\' class=\'w-100 p-2\'name=\'products[' + next_product + '][document]\'  placeholder=\'Numer dokumentu zakupu\' required/>\n                              </div>\n                              <button class="delete_row">\n                                <i class="fa fa-times-circle"></i>\n                              </button>\n                          </div>\n                        </div>';
        products_wrapper.append(template);
    });

    $('body').on('click', ".form_with_products .product-row button.delete_row", function () {
        var confirmed = confirm("Czy chcesz usunąć ten produkt ?");
        if (confirmed) {
            var row = $(this).closest('.product-row');
            row.remove();
            setTimeout(function () {
                $(".form_with_products .product-row").each(function (index) {
                    var i = index + 1;
                    $(this).attr('data-product', i);
                    $(this).find('.lp').html(i);
                });
            }, 150);
        }
    });
});

},{"./modules/carousels":"/Users/lukasz/Sites/directimport/www/resources/assets/scripts/src/modules/carousels.js","./modules/cookies":"/Users/lukasz/Sites/directimport/www/resources/assets/scripts/src/modules/cookies.js","./modules/googleMaps":"/Users/lukasz/Sites/directimport/www/resources/assets/scripts/src/modules/googleMaps.js","./modules/imagePopUp":"/Users/lukasz/Sites/directimport/www/resources/assets/scripts/src/modules/imagePopUp.js","./modules/miniGallery":"/Users/lukasz/Sites/directimport/www/resources/assets/scripts/src/modules/miniGallery.js","./modules/parallax":"/Users/lukasz/Sites/directimport/www/resources/assets/scripts/src/modules/parallax.js","./modules/scrollTo":"/Users/lukasz/Sites/directimport/www/resources/assets/scripts/src/modules/scrollTo.js","./modules/sidePanel":"/Users/lukasz/Sites/directimport/www/resources/assets/scripts/src/modules/sidePanel.js","./modules/svgInjector":"/Users/lukasz/Sites/directimport/www/resources/assets/scripts/src/modules/svgInjector.js","./modules/validator":"/Users/lukasz/Sites/directimport/www/resources/assets/scripts/src/modules/validator.js","./modules/video":"/Users/lukasz/Sites/directimport/www/resources/assets/scripts/src/modules/video.js","./modules/visible":"/Users/lukasz/Sites/directimport/www/resources/assets/scripts/src/modules/visible.js"}],"/Users/lukasz/Sites/directimport/www/resources/assets/scripts/src/modules/carousels.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Carousels = exports.Carousels = function () {
    function Carousels() {
        _classCallCheck(this, Carousels);
    }

    _createClass(Carousels, [{
        key: 'init',
        value: function init() {
            var carouselThumbs2 = $('.gallery-thumbs .owl-carousel, .article-list__slider .owl-carousel, .slider .owl-carousel, .gallery-category--logos .owl-carousel'),
                carouselThumbs = $('.slider.slider-investitions .owl-carousel '),
                carouselZoom = $('.gallery-category--zoom-slider .owl-carousel '),
                pluginFlag = carouselThumbs.length || carouselZoom.length;

            if (pluginFlag) if (carouselThumbs) this.carouselThumbs(carouselThumbs);
            if (carouselThumbs2) this.carouselThumbs2(carouselThumbs2);
            if (carouselZoom) this.carouselZoom(carouselZoom);

            $('.swiper-container.gallery-top').each(function (index) {
                var autoplay = false;
                if ($(this).data('autoplay') && $(this).data('autoplay') === true) {
                    autoplay = {
                        delay: $(this).data('autoplayDelay') ? $(this).data('autoplayDelay') : 1500,
                        disableOnInteraction: true
                    };
                }

                var galleryTop = new Swiper($(this), {
                    slidesPerView: $(this).data('items'),
                    effect: 'flip',
                    grabCursor: true,
                    loopedSlides: $(this).find('.swiper-slide').length,
                    loop: $(this).data('loop') ? $(this).data('loop') : false,
                    centeredSlides: $(this).data('slideCenter') || $(this).data('loop') === true && $(this).siblings('.swiper-container.gallery-thumbs').length > 0 ? true : false,
                    spaceBetween: 30,
                    pagination: {
                        el: $(this).children('.swiper-pagination')
                    },
                    autoplay: autoplay,
                    navigation: {
                        nextEl: $(this).children('.swiper-button-next'),
                        prevEl: $(this).children('.swiper-button-prev')
                    },
                    breakpoints: {
                        1200: {
                            slidesPerView: $(this).data('itemsXl') ? $(this).data('itemsXl') : $(this).data('items'),
                            spaceBetween: 40
                        },
                        992: {
                            slidesPerView: $(this).data('itemsLg') ? $(this).data('itemsLg') : $(this).data('items'),
                            spaceBetween: 30
                        },
                        768: {
                            slidesPerView: $(this).data('itemsMd') ? $(this).data('itemsMd') : $(this).data('items'),
                            spaceBetween: 20
                        },
                        576: {
                            slidesPerView: $(this).data('itemsSm') ? $(this).data('itemsSm') : $(this).data('items'),
                            spaceBetween: 10
                        }
                    }
                });

                var galleryThumbs = new Swiper($(this).siblings('.swiper-container.gallery-thumbs'), {
                    spaceBetween: 10,
                    centeredSlides: true,
                    slidesPerView: 'auto',
                    touchRatio: 0.2,
                    slideToClickedSlide: true,
                    loopedSlides: $(this).find('.swiper-slide').length,
                    loop: $(this).data('loop') ? $(this).data('loop') : false
                });

                if (galleryThumbs.controller && galleryThumbs.controller !== "undefined") {
                    galleryTop.controller.control = galleryThumbs;
                    galleryThumbs.controller.control = galleryTop;
                }
            });
        }
    }, {
        key: 'carouselThumbs2',
        value: function carouselThumbs2(carousel) {
            carousel.owlCarousel({
                items: 8,
                loop: true,
                margin: 20,
                nav: false,
                navText: ['<i class="fa fa-arrow-circle-o-left"></i>', '<i class="fa fa-arrow-circle-o-right"></i>'],
                dots: false,
                thumbs: true,
                autoplay: typeof carousel.data('autoplay') !== 'undefined' ? carousel.data('autoplay') : false,
                autoplayTimeout: 2000,
                thumbsPrerendered: true,
                responsive: {
                    0: {
                        items: 3,
                        autoWidth: true
                    },
                    320: {
                        items: 3
                    },
                    641: {
                        items: 4,
                        autoWidth: true,
                        center: false
                    },
                    1024: {
                        items: 6,
                        center: true,
                        autoWidth: true
                    },
                    1350: {
                        items: 8,
                        center: true,
                        autoWidth: true
                    }
                },
                onChanged: function onChanged(e) {
                    var itemsLength = this._items.length;

                    var $slider = this.$element.closest('.slider'),
                        $slides = $slider.find('.owl-carousel .owl-item:not(.cloned)'),
                        $thumbsContainer = $slider.find('.slider-thumbs'),
                        $thumbsList = $slider.find('.owl-thumbs');

                    var thumbWidth = $thumbsList.find('.owl-thumb-item').outerWidth(true),
                        thumbsListWidth = thumbWidth * itemsLength,
                        thumbsContainerWidth = $thumbsContainer.width();

                    var thumbsOuterWidth = thumbsListWidth - thumbsContainerWidth,
                        thumbsPositionPart = thumbsOuterWidth / itemsLength;

                    var currentPosition = $thumbsList.find('.owl-thumb-item.active').index(),
                        currentSlide = $slides.eq(currentPosition);

                    var firstMarginLeft = parseInt($thumbsList.find('.owl-thumb-item').first().css('margin-left')),
                        lastMarginRight = parseInt($thumbsList.find('.owl-thumb-item').last().css('margin-right'));

                    var offset = currentPosition === 0 ? -firstMarginLeft : currentPosition === itemsLength - 1 ? thumbsContainerWidth - thumbsListWidth + lastMarginRight : (-currentPosition + 1) * thumbsPositionPart - firstMarginLeft;

                    if (thumbsOuterWidth <= 0) {
                        $thumbsList.css({
                            '-webkit-transform': 'translateX(' + -firstMarginLeft + 'px)',
                            '-mox-transform': 'translateX(' + -firstMarginLeft + 'px)',
                            'transform': 'translateX(' + -firstMarginLeft + 'px)'
                        });
                    } else if (thumbsOuterWidth > 0) {
                        $thumbsList.css({
                            '-webkit-transform': 'translateX(' + offset + 'px)',
                            '-mox-transform': 'translateX(' + offset + 'px)',
                            'transform': 'translateX(' + offset + 'px)'
                        });
                    }

                    setTimeout(function () {
                        currentSlide.addClass('active');
                    });
                }
            });
        }
    }, {
        key: 'carouselThumbs',
        value: function carouselThumbs(carousel) {
            carousel.owlCarousel({
                items: 1,
                loop: true,
                margin: 20,
                nav: false,
                navText: ['<i class="fa fa-arrow-circle-o-left"></i>', '<i class="fa fa-arrow-circle-o-right"></i>'],
                dots: false,
                thumbs: true,
                autoplay: false,
                //            autoplayTimeout: 2000,
                thumbsPrerendered: true,
                responsive: {
                    0: {
                        items: 1
                        //                    autoWidth: true
                    },
                    320: {
                        items: 1
                    },
                    641: {
                        items: 1,
                        //                    autoWidth: true,
                        center: false
                    },
                    1024: {
                        items: 1,
                        center: true
                        //                    autoWidth: true
                    },
                    1350: {
                        items: 1,
                        center: true
                        //                    autoWidth: true
                    }
                },
                onChanged: function onChanged(e) {
                    var itemsLength = this._items.length;

                    var $slider = this.$element.closest('.slider'),
                        $slides = $slider.find('.owl-carousel .owl-item:not(.cloned)'),
                        $thumbsContainer = $slider.find('.slider-thumbs'),
                        $thumbsList = $slider.find('.owl-thumbs');

                    var thumbWidth = $thumbsList.find('.owl-thumb-item').outerWidth(true),
                        thumbsListWidth = thumbWidth * itemsLength,
                        thumbsContainerWidth = $thumbsContainer.width();

                    var thumbsOuterWidth = thumbsListWidth - thumbsContainerWidth,
                        thumbsPositionPart = thumbsOuterWidth / itemsLength;

                    var currentPosition = $thumbsList.find('.owl-thumb-item.active').index(),
                        currentSlide = $slides.eq(currentPosition);

                    var firstMarginLeft = parseInt($thumbsList.find('.owl-thumb-item').first().css('margin-left')),
                        lastMarginRight = parseInt($thumbsList.find('.owl-thumb-item').last().css('margin-right'));

                    var offset = currentPosition === 0 ? -firstMarginLeft : currentPosition === itemsLength - 1 ? thumbsContainerWidth - thumbsListWidth + lastMarginRight : (-currentPosition + 1) * thumbsPositionPart - firstMarginLeft;

                    if (thumbsOuterWidth <= 0) {
                        $thumbsList.css({
                            '-webkit-transform': 'translateX(' + -firstMarginLeft + 'px)',
                            '-mox-transform': 'translateX(' + -firstMarginLeft + 'px)',
                            'transform': 'translateX(' + -firstMarginLeft + 'px)'
                        });
                    } else if (thumbsOuterWidth > 0) {
                        $thumbsList.css({
                            '-webkit-transform': 'translateX(' + offset + 'px)',
                            '-mox-transform': 'translateX(' + offset + 'px)',
                            'transform': 'translateX(' + offset + 'px)'
                        });
                    }

                    setTimeout(function () {
                        currentSlide.addClass('active');
                    });
                }
            });
        }
    }, {
        key: 'carouselZoom',
        value: function carouselZoom(carousel) {
            carousel.owlCarousel({
                stagePadding: 0,
                loop: false,
                autoWidth: true,
                center: true,
                margin: 0,
                responsive: {
                    0: {
                        items: 3,
                        autoWidth: true
                    },
                    320: {
                        items: 3
                    },
                    641: {
                        items: 4,
                        autoWidth: true,
                        center: false
                    },
                    1024: {
                        items: 6,
                        center: true,
                        autoWidth: true
                    },
                    1350: {
                        items: 8,
                        center: true,
                        autoWidth: true
                    }
                }
            });

            carousel.find('.owl-item').on('click', function () {
                var $this = $(this),
                    index = $this.index(),
                    itemsLength = $this.siblings('.owl-item').length,
                    itemsHandler = $this.closest('.owl-stage-outer'),
                    activeItems = $this.closest('.gallery-category--zoom-slider').find('.active');

                if ($this.hasClass('zoomed')) {
                    $this.removeClass('zoomed');
                } else if ($this.prev().hasClass('active') && $this.next().hasClass('active') || !$this.prev().hasClass('active') && !$this.next().hasClass('active')) {
                    $('.zoomed').removeClass('zoomed');
                    $this.addClass('zoomed');
                } else if ($this.prev().hasClass('active') && !$this.next().hasClass('active')) {
                    carousel.trigger('next.owl.carousel', [500]);
                    $('.zoomed').removeClass('zoomed');
                    $this.addClass('zoomed');
                } else if (!$this.prev().hasClass('active') && $this.next().hasClass('active')) {
                    carousel.trigger('prev.owl.carousel', [500]);
                    $('.zoomed').removeClass('zoomed');
                    $this.addClass('zoomed');
                }
            });
        }
    }]);

    return Carousels;
}();

},{}],"/Users/lukasz/Sites/directimport/www/resources/assets/scripts/src/modules/cookies.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Cookies = exports.Cookies = function () {
	function Cookies() {
		_classCallCheck(this, Cookies);
	}

	_createClass(Cookies, [{
		key: 'init',
		value: function init() {
			var self = this;
			$(document).ready(function () {

				if (self.getCookie("cookie_agree") == 1) {
					$('.cookies-tab').hide();
				} else {
					$('.cookies-tab').show();
				}

				$('.cookies-tab .button').click(function () {
					self.cookieAgree();
					return false;
				});
				if (self.getCookie("promotion") != 1) {
					setTimeout(function () {
						$('.promoted-product-modal-wrapper').fadeIn();
					}, 1500);
				}
				$('.promoted-product-modal-wrapper .close-button').on('click', function () {
					self.setCookie("promotion", 1, 7);
					$('.promoted-product-modal-wrapper').fadeOut();
				});
			});
		}
	}, {
		key: 'cookieAgree',
		value: function cookieAgree() {
			var self = this;
			self.setCookie("cookie_agree", 1, 365);
			$('.cookies-tab').fadeOut(400);
		}
	}, {
		key: 'getCookie',
		value: function getCookie(name) {
			var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
			return v ? v[2] : null;
		}
	}, {
		key: 'setCookie',
		value: function setCookie(name, value, days) {
			var d = new Date();
			d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
			document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
		}
	}]);

	return Cookies;
}();

},{}],"/Users/lukasz/Sites/directimport/www/resources/assets/scripts/src/modules/googleMaps.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GoogleMaps = exports.GoogleMaps = function () {
	function GoogleMaps() {
		_classCallCheck(this, GoogleMaps);
	}

	_createClass(GoogleMaps, [{
		key: 'init',
		value: function init() {
			var self = this;
			if ($('.google-map').length) {
				$(document).ready(function () {
					self.geocode();
				});
			}
		}
	}, {
		key: 'geocode',
		value: function geocode() {
			$('.google-map').each(function (id, mapSection) {
				var address = $(mapSection).data('address'),
				    mapContent = $(mapSection).find('.google-map__content').attr('id');
				var mapOptions = {
					zoom: 15,
					center: new google.maps.LatLng(40.6700, -73.9400),
					styles: [{ "featureType": "all", "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#000000" }, { "lightness": 40 }] }, { "featureType": "all", "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }, { "color": "#000000" }, { "lightness": 16 }] }, { "featureType": "all", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#000000" }, { "lightness": 20 }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#000000" }, { "lightness": 17 }, { "weight": 1.2 }] }, { "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [{ "color": "#8b9198" }] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 20 }] }, { "featureType": "landscape", "elementType": "geometry.fill", "stylers": [{ "color": "#323336" }] }, { "featureType": "landscape.man_made", "elementType": "geometry.stroke", "stylers": [{ "color": "#414954" }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 21 }] }, { "featureType": "poi", "elementType": "geometry.fill", "stylers": [{ "color": "#2e2f31" }] }, { "featureType": "road", "elementType": "labels.text.fill", "stylers": [{ "color": "#7a7c80" }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#242427" }, { "lightness": 17 }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#202022" }, { "lightness": 29 }, { "weight": 0.2 }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 18 }] }, { "featureType": "road.arterial", "elementType": "geometry.fill", "stylers": [{ "color": "#393a3f" }] }, { "featureType": "road.arterial", "elementType": "geometry.stroke", "stylers": [{ "color": "#202022" }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 16 }] }, { "featureType": "road.local", "elementType": "geometry.fill", "stylers": [{ "color": "#393a3f" }] }, { "featureType": "road.local", "elementType": "geometry.stroke", "stylers": [{ "color": "#202022" }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 19 }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 17 }] }, { "featureType": "water", "elementType": "geometry.fill", "stylers": [{ "color": "#202124" }] }]
				};

				var mapElement = document.getElementById(mapContent);

				var map = new google.maps.Map(mapElement, mapOptions);
				var geocoder = new google.maps.Geocoder();
				geocoder.geocode({ 'address': address }, function (results, status) {
					if (status == google.maps.GeocoderStatus.OK) {
						map.setCenter(results[0].geometry.location);
						var marker = new google.maps.Marker({
							map: map,
							position: results[0].geometry.location
						});
					}
				});
			});
		}
	}]);

	return GoogleMaps;
}();

},{}],"/Users/lukasz/Sites/directimport/www/resources/assets/scripts/src/modules/imagePopUp.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ImagePopUp = exports.ImagePopUp = function () {
    function ImagePopUp() {
        _classCallCheck(this, ImagePopUp);
    }

    _createClass(ImagePopUp, [{
        key: 'init',
        value: function init() {
            $('.picture a, .image a').magnificPopup({
                type: 'image',
                closeOnContentClick: true,
                closeBtnInside: false,
                fixedContentPos: true,
                mainClass: 'mfp-no-margins mfp-with-zoom',
                image: {
                    verticalFit: true
                },
                zoom: {
                    enabled: true,
                    duration: 300
                }
            });
            $('.swiper-container a').magnificPopup({
                type: 'image'
            });
            $('.slider-investitions .slider__item').magnificPopup({
                type: 'image'
            });
        }
    }]);

    return ImagePopUp;
}();

},{}],"/Users/lukasz/Sites/directimport/www/resources/assets/scripts/src/modules/miniGallery.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MiniGallery = exports.MiniGallery = function () {
    function MiniGallery() {
        _classCallCheck(this, MiniGallery);
    }

    _createClass(MiniGallery, [{
        key: 'init',
        value: function init() {
            var miniGalleryLength = $('.gallery').length,
                noGridGalleryLength = $('.js-no-grid').length;

            if (miniGalleryLength) {
                for (var i = miniGalleryLength; i--;) {
                    $('.gallery').eq(i).magnificPopup({
                        delegate: 'a',
                        type: 'image',
                        closeOnContentClick: true,
                        closeBtnInside: false,
                        fixedContentPos: true,
                        mainClass: 'mfp-no-margins mfp-with-zoom', // class to remove default margin from left and right side
                        image: {
                            verticalFit: true
                        },
                        tLoading: 'Ładuję...',
                        gallery: {
                            enabled: true,
                            tCounter: '<span class="mfp-counter">%curr% z %total%</span>'
                        },
                        zoom: {
                            enabled: false,
                            duration: 300 // don't foget to change the duration also in CSS
                        }
                    });
                }
            }
        }
    }]);

    return MiniGallery;
}();

},{}],"/Users/lukasz/Sites/directimport/www/resources/assets/scripts/src/modules/parallax.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Parallax = exports.Parallax = function () {
    function Parallax() {
        _classCallCheck(this, Parallax);
    }

    _createClass(Parallax, [{
        key: 'init',
        value: function init($sections) {
            if ($(window).width() > 1020) {
                $(window).scroll(function () {
                    var wScrollTop = $(window).scrollTop();
                    $('[data-parallax="true"]').each(function (id, item) {
                        if ($(this).visible(true)) {
                            var itemTop = $(this).offset().top;
                            var s = wScrollTop - itemTop;
                            $(this).find('.parallax-bg').css({
                                'transform': 'translateY(' + s * 0.3 + 'px)',
                                '-webkit-transform': 'translateY(' + s * 0.3 + 'px)',
                                '-moz-transform': 'translateY(' + s * 0.3 + 'px)'
                            });
                        }
                    });
                });
            }
        }
    }]);

    return Parallax;
}();

},{}],"/Users/lukasz/Sites/directimport/www/resources/assets/scripts/src/modules/scrollTo.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ScrollTo = exports.ScrollTo = function () {
	function ScrollTo() {
		_classCallCheck(this, ScrollTo);
	}

	_createClass(ScrollTo, [{
		key: 'init',
		value: function init() {
			$('.scroll-to a').on('click', function (e) {
				e.preventDefault();
				var distElement = $(this).attr('href'),
				    distElementTop = $(distElement).offset().top - 15;

				$('html, body').animate({
					scrollTop: distElementTop
				}, 500);
			});
		}
	}]);

	return ScrollTo;
}();

},{}],"/Users/lukasz/Sites/directimport/www/resources/assets/scripts/src/modules/sidePanel.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SidePanel = exports.SidePanel = function () {
	function SidePanel() {
		_classCallCheck(this, SidePanel);
	}

	_createClass(SidePanel, [{
		key: 'init',
		value: function init() {
			if ((typeof sidePanelOptions === 'undefined' ? 'undefined' : _typeof(sidePanelOptions)) == 'object') {
				var self = this,
				    cookieFlag = self.getCookie('side-panel-' + sidePanelOptions.siteId),
				    currentCookie = cookieFlag != null ? JSON.parse(cookieFlag) : null,
				    body = $('body');

				$(document).ready(function () {
					if (currentCookie == null || currentCookie.id != sidePanelOptions.id) {
						sidePanelOptions.closed = 0;
						self.setCookie('side-panel-' + sidePanelOptions.siteId, JSON.stringify(sidePanelOptions), 365);
						self.checkRevealType();
					} else {
						if (currentCookie.closed == 0 && sidePanelOptions.reactive == 0 || currentCookie.closed == 1 && currentCookie.reactive == 0 && sidePanelOptions.reactive == 1) {
							self.checkRevealType();
						}
					}

					body.on('click', '.side-panel__close', function () {
						self.hidePanel();
					});
					body.on('click', '.side-panel.close', function () {
						self.reopenPanel();
					});
				});
			}
		}
	}, {
		key: 'reopenPanel',
		value: function reopenPanel() {
			$('.side-panel').fadeOut(function () {
				$(this).removeClass('close').addClass('open').fadeIn();
			});
		}
	}, {
		key: 'showPanel',
		value: function showPanel() {
			$('.side-panel').fadeIn(function () {
				$(this).removeClass('close').addClass('open');
			});
		}
	}, {
		key: 'hidePanel',
		value: function hidePanel() {
			var self = this;
			$('.side-panel').fadeOut(function () {
				$(this).removeClass('open').addClass('close').show();
			});
			var cookie = self.getCookie('side-panel-' + sidePanelOptions.siteId);
			var parsedCookie = JSON.parse(cookie);

			parsedCookie.closed = 1;
			sidePanelOptions.reactive == 1 ? parsedCookie.reactive = 1 : parsedCookie.reactive = 0;
			self.setCookie('side-panel-' + sidePanelOptions.siteId, JSON.stringify(parsedCookie), 365);
		}
	}, {
		key: 'showAfterTime',
		value: function showAfterTime(time) {
			var self = this;
			var delay = parseInt(time) * 1000;
			setTimeout(function () {
				self.showPanel();
			}, delay);
		}
	}, {
		key: 'showAfterDistance',
		value: function showAfterDistance(distance) {
			var self = this,
			    notClosed = true;
			$(window).scroll(function () {
				var st = $(window).scrollTop();

				if (st > distance && notClosed) {
					self.showPanel();
					notClosed = false;
				}
			});
		}
	}, {
		key: 'checkRevealType',
		value: function checkRevealType() {
			var self = this;

			if (sidePanelOptions.distance != 0) {
				self.showAfterDistance(sidePanelOptions.distance);
			} else if (sidePanelOptions.time != 0) {
				self.showAfterTime(sidePanelOptions.time);
			}
		}
	}, {
		key: 'getCookie',
		value: function getCookie(name) {
			var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
			return v ? v[2] : null;
		}
	}, {
		key: 'setCookie',
		value: function setCookie(name, value, days) {
			var d = new Date();
			d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
			document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
		}
	}]);

	return SidePanel;
}();

},{}],"/Users/lukasz/Sites/directimport/www/resources/assets/scripts/src/modules/svgInjector.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SvgInjector = exports.SvgInjector = function () {
	function SvgInjector() {
		_classCallCheck(this, SvgInjector);
	}

	_createClass(SvgInjector, [{
		key: 'init',
		value: function init() {
			var mySVGsToInject = document.querySelectorAll('img.inject-svg');
			SVGInjector(mySVGsToInject, {}, function () {
				$('.contact-map--transparent path').hover(function () {
					var pathID = $(this).attr('id');
					$('.contact-map--color path[id="' + pathID + '"]').css({ 'fill': '#003179' });
				}, function () {
					$('.contact-map--color path').css({ 'fill': 'rgb(210, 220, 237)' });
				});

				$('.contact-map--transparent path').on('click', function () {
					$('.map-infos').hide();
					var tabID = $(this).attr('id');
					$('.contact-map--color path').attr('class', 'swisspor-area');
					$('.contact-map--color path[id="' + tabID + '"]').attr('class', 'swisspor-area active');
					$('.map-item').hide();
					$('.map-item[data-tab="' + tabID + '"]').show();
				});

				$('.js--regions').on('click', function () {
					$(this).closest('.map-item__regions').find('.regions-list').slideToggle();
				});
			});
		}
	}]);

	return SvgInjector;
}();

},{}],"/Users/lukasz/Sites/directimport/www/resources/assets/scripts/src/modules/validator.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Validator = exports.Validator = function () {
	function Validator() {
		_classCallCheck(this, Validator);
	}

	_createClass(Validator, [{
		key: 'init',
		value: function init() {
			if ((typeof contactFormRules === 'undefined' ? 'undefined' : _typeof(contactFormRules)) == 'object') {
				$('#contactForm').validate({
					rules: contactFormRules,
					errorPlacement: function errorPlacement(error, element) {},
					submitHandler: function submitHandler(text) {
						$.ajax({
							url: $('#contactForm').attr("action"),
							method: 'POST',
							data: $('#contactForm').serialize(),
							beforeSend: function beforeSend() {
								$('#contactForm').find('button').prop('disabled', 'disabled');
							},
							success: function success() {
								$('#contactForm').find('input, textarea').val('');
								$('#contactForm').fadeOut(500, function () {
									$('#contactForm').replaceWith('<div class="form__message form__message--success">Wiadomość została wysłana. Dziękujemy.</div>').fadeIn(500);
								});
							},
							error: function error() {
								$('#contactForm').find('input, textarea').val('');
								$('#contactForm').fadeOut(500, function () {
									$('#contactForm').replaceWith('<div class="form__message form__message--error">Wiadomość nie została wysłana. Prosimy spróbować później.</div>').fadeIn(500);
								});
							}
						});
					}
				});
			}
		}
	}]);

	return Validator;
}();

},{}],"/Users/lukasz/Sites/directimport/www/resources/assets/scripts/src/modules/video.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Video = exports.Video = function () {
	function Video() {
		_classCallCheck(this, Video);
	}

	_createClass(Video, [{
		key: 'init',
		value: function init() {
			var self = this;
			$('.video-player').hover(function (e) {
				e.preventDefault();
				var $this = $(this);
				self.play($this);
			}, function (e) {
				e.preventDefault();
				var $this = $(this);
				self.stop($this);
			});
		}
	}, {
		key: 'play',
		value: function play(video) {
			var videoType = video.data('type');
			if (videoType == 'youtube') {
				video = $(video)[0].contentWindow;
				video.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
			} else if (videoType == 'video') {
				video = video.get(0);
				video.play();
			}
		}
	}, {
		key: 'stop',
		value: function stop(video) {
			var videoType = video.data('type');
			if (videoType == 'youtube') {
				video = $(video)[0].contentWindow;
				video.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
			} else if (videoType == 'video') {
				video = video.get(0);
				video.pause();
			}
		}
	}]);

	return Video;
}();

},{}],"/Users/lukasz/Sites/directimport/www/resources/assets/scripts/src/modules/visible.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Visible = exports.Visible = function () {
	function Visible() {
		_classCallCheck(this, Visible);
	}

	_createClass(Visible, [{
		key: 'init',
		value: function init() {
			var elem = $('.features-list__item, .features-list-item, .features-list-submenu, .image, .articles-list__item, .ex-text, .ask-adviser, .form');

			elem.each(function () {
				var $this = $(this),
				    elemVisible = $this.visible(true, 'vertical');

				if (elemVisible) {
					$this.addClass('on-screen', elemVisible);
					setTimeout(function () {
						$this.addClass('triggered');
					}, 500);
				}
			});

			$(window).scroll(function () {
				elem.each(function () {
					var $this = $(this),
					    elemVisible = $this.visible(true, 'vertical');

					if (elemVisible) {
						$this.addClass('on-screen', elemVisible);
						setTimeout(function () {
							$this.addClass('triggered');
						}, 500);
					}
				});
			});
			this.delay($('.articles-list--blog .articles-list__item'));
			this.delay($('.features-list .features-list__item'));
			this.delay($('.gallery--home .gallery--home__item'));
			this.delay($('.offer .col-12'));
		}
	}, {
		key: 'delay',
		value: function delay(elem) {
			elem.each(function (index) {
				$(this).css('transition-delay', 300 + 250 * index + 'ms');
			});
		}
	}]);

	return Visible;
}();

},{}]},{},["/Users/lukasz/Sites/directimport/www/resources/assets/scripts/src/main.js"])

